import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SwalService {

  constructor(private translateService: TranslateService,
  ) { }

  getSettingDefaultSuccess() {
    return {
      title: this.translateService.instant('SW_MESSAGE1'),
      html: this.translateService.instant('SW_BODY1'),
      type: 'success',
      allowOutsideClick: false
    }
  }

  getSettingDefaultError() {
    return {
      title: this.translateService.instant('SW_HEAD2'),
      html: this.translateService.instant('SW_BODY2'),
      type: 'error'
    }
  }
  getSettingEmailConfermationSuccess() {
    return {
      title: this.translateService.instant('SW_MESSAGE1'),
      html: this.translateService.instant('SUCCESSFULY_SAVED'),
      confirmButtonText: this.translateService.instant('SW_MESSAGE1'),
      allowOutsideClick: false
    }
  }

  getSettingDeleteSuccess() {
    return {
      title: this.translateService.instant('ARE_YOU_SURE_REOMOVE'),
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translateService.instant('YES'),
      cancelButtonText: this.translateService.instant('NO'),
      confirmButtonClass: 'btn btn-success btn-gh',
      cancelButtonClass: 'btn btn-danger btn-remv',
      buttonsStyling: false
    }
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/swal.service.ts